import { FOfferType, offerTypeFromJsonQuery } from './category';
import { IJsonQuery } from '../repositories/common/json_query';

export function shouldSendAdsEvent(jsonQuery: IJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return [FOfferType.Flat, FOfferType.FlatNew, FOfferType.FlatOld].includes(offerType);
}
